import { h, Fragment } from "preact";
import { Edit } from "../../helpers/icons";
import StockStatus from "../stock-status/stock-status";
import ProductOptions from "../product-options/product-options";
import {
  productOptionSwatchStyles,
  productOptionSizes,
} from "../product-options/product-option-styles";
import QuantityInput from "../../global/quantity-input/quantity-input-react";
import { unavailableStockStatuses } from "../product-options/product-option-styles";

export default function ProductSetItemFormInline({
  product,
  item,
  itemId,
  idPrefix,
  enableAvailabilityPreview,
  updateItem,
}) {
  if (!product) return null;

  const { variant, quantity } = item;

  return (
    <div className="product-set-item__content product-set-item-form-inline">
      <div className="product-set-item-form-inline__title">{product.title}</div>
      <ProductOptions
        productId={product.id}
        idPrefix={idPrefix}
        initialVariantId={item.variant.id}
        enableSwatchPreview={false}
        enableAccordions={false}
        quantityRequested={1}
        enableAvailabilityPreview={enableAvailabilityPreview}
        onVariantChanged={({ variant }) => variant && updateItem({ variant })}
        optionSize={productOptionSizes.small}
        disabledSwatchStyle={productOptionSwatchStyles.dashed}
        unavailableStockStatuses={unavailableStockStatuses.notInStock}
      />
      <StockStatus
        productId={product.id}
        variantId={variant.id}
        quantityRequested={quantity}
        countryCode={window.theme.country}
      />
      <div className="product-set-item-form-inline__footer">
        <price-snippet
          className="product-set-item-form-inline__price"
          DYNAMIC
          PRICE={parseFloat(variant.price.amount)}
          COMPARE-AT-PRICE={parseFloat(variant.compareAtPrice?.amount || 0)}
          CURRENCY={variant.price.currencyCode}
        ></price-snippet>
        <QuantityInput
          quantity={item.quantity}
          setQuantity={(quantity) => updateItem({ quantity })}
          max={variant.maxQuantityThreshold}
        />
      </div>
    </div>
  );
}
